import { render, staticRenderFns } from "./GoodsVideo.vue?vue&type=template&id=55371b21&"
import script from "./GoodsVideo.vue?vue&type=script&lang=js&"
export * from "./GoodsVideo.vue?vue&type=script&lang=js&"
import style0 from "./GoodsVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports